module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropdown-circle.ac67ab6d.svg";